import { c as _c } from "react/compiler-runtime";
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { withErrorBoundary } from 'shared/hocs/with-error-boundary';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { ContactId } from '../../types/contact-interface';
import { useContactCommunities } from '../hooks/use-contact-communities';
import { ContactCommunitiesInterface } from '../types/contact-communities-interface';
import { getLoginCommunityUrl } from 'modules/commutinies/utils/get-community-url';
interface ContactCommunitiesProps {
  contactId: ContactId;
}
const ContactCommunities = t0 => {
  const $ = _c(27);
  const {
    contactId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    pagination,
    setPagination,
    limit,
    setLimit
  } = usePagination(true);
  let t1;
  if ($[0] !== contactId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      pagination,
      limit,
      contactId
    };
    $[0] = contactId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    contactCommunities
  } = useContactCommunities(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.contact_page.communities.headers.name");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = [{
      key: "community",
      header: t2,
      onRender: _temp
    }];
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const columns = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.communities.title_plural");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <h2 className="h-[42px] text-[17px] font-bold">{t4}</h2>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== limit || $[13] !== setLimit) {
    t6 = {
      limit,
      setLimit
    };
    $[12] = limit;
    $[13] = setLimit;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== pagination || $[16] !== setPagination) {
    t7 = {
      pagination,
      setPagination
    };
    $[15] = pagination;
    $[16] = setPagination;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== columns || $[19] !== contactCommunities || $[20] !== t6 || $[21] !== t7) {
    t8 = <Table columns={columns} data={contactCommunities} limiter={t6} paginator={t7} nestedId="community" />;
    $[18] = columns;
    $[19] = contactCommunities;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== contactCommunities || $[24] !== t5 || $[25] !== t8) {
    t9 = <ListingLayout data={contactCommunities} counter={false} title={t5} type="compact">{t8}</ListingLayout>;
    $[23] = contactCommunities;
    $[24] = t5;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
export default withErrorBoundary(ContactCommunities);
function _temp(t0) {
  const {
    community
  } = t0;
  return <div className="truncate"><a target="_blank" rel="noreferrer" className="primary-link w-full" href={getLoginCommunityUrl(community)}>{community.name}</a></div>;
}